module.exports = __webpack_public_path__ + "static/media/SocialSupport.dcf715af.svg";